__turbopack_context__.v({
  "blur": "LazyImage-module-scss-module__f8u61G__blur",
  "contentImage": "LazyImage-module-scss-module__f8u61G__contentImage",
  "imagesSq": "LazyImage-module-scss-module__f8u61G__imagesSq",
  "unblur": "LazyImage-module-scss-module__f8u61G__unblur",
});
